export const shouldLoadWhatsApps = ({ authLoading, isAuth, userId }) =>
	!authLoading && Boolean(isAuth) && Boolean(userId);
